export default {
  acceptedshipment: {
    title: "Отчет о принятой отгрузке",
    period: "Период",
    periodNotSelected: "Поле период не может быть пустым"
  }
};
